import { Component, Renderer2, ViewChild } from '@angular/core';

import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { FluidModule } from 'primeng/fluid';
import { AppCommonFooter } from '../common/app.common.footer';
import { SplitterModule } from 'primeng/splitter';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table'; 
import { AppClientTopbar } from '../common/app.client.topbar';
//import { CardsComponent } from "../../../client/test/test.component";
import { AppClientLayout } from "../client/app.client.layout";

@Component({
    selector: 'app-login-layout',
    standalone: true,
    imports: [FluidModule, PanelModule, RouterModule, SplitterModule, TableModule, AppClientTopbar, AppClientLayout],
    template: `<div class="layout-wrapper">
    <app-client-topbar></app-client-topbar>
    <app-client-layout></app-client-layout>
<!--
    <div class="layout-login-main-container"> 
        <div class="layout-main">  
        <div class="font-login-title" >
            digital services platform for tenaris customers
        </div> 
         <router-outlet></router-outlet>       
       </div> 
    </div> 

    <app-common-footer></app-common-footer>-->
</div>

<div class="layout-mask animate-fadein"></div>`
})

export class AppLoginLayout {
    menuOutsideClickListener: any;

    @ViewChild(AppClientTopbar) appTopBar!: AppClientTopbar;

    panelMenuItems = [
        {
            label: 'Customers',
            icon: 'pi pi-fw pi-table',
            items: [
                {
                    label: 'New',
                    icon: 'pi pi-fw pi-user-plus',
                    items: [
                        {
                            label: 'Customer',
                            icon: 'pi pi-fw pi-plus'
                        },
                        {
                            label: 'Duplicate',
                            icon: 'pi pi-fw pi-copy'
                        }
                    ]
                },
                {
                    label: 'Edit',
                    icon: 'pi pi-fw pi-user-edit'
                }
            ]
        },
        {
            label: 'Orders',
            icon: 'pi pi-fw pi-shopping-cart',
            items: [
                {
                    label: 'View',
                    icon: 'pi pi-fw pi-list'
                },
                {
                    label: 'Search',
                    icon: 'pi pi-fw pi-search'
                }
            ]
        },
        {
            label: 'Shipments',
            icon: 'pi pi-fw pi-envelope',
            items: [
                {
                    label: 'Tracker',
                    icon: 'pi pi-fw pi-compass'
                },
                {
                    label: 'Map',
                    icon: 'pi pi-fw pi-map-marker'
                },
                {
                    label: 'Manage',
                    icon: 'pi pi-fw pi-pencil'
                }
            ]
        },
        {
            label: 'Profile',
            icon: 'pi pi-fw pi-user',
            items: [
                {
                    label: 'Settings',
                    icon: 'pi pi-fw pi-cog'
                },
                {
                    label: 'Billing',
                    icon: 'pi pi-fw pi-file'
                }
            ]
        }
    ];

    constructor(
        public renderer: Renderer2,
        public router: Router
    ) {

       
    }
}
